/**
 * Tour keys for onboarding progress tracking.
 * These keys correspond to the backend onboardingProgress JSON structure.
 */
export const TOUR_KEYS = {
  // Welcome tour + intro steps on portfolio page
  MAIN: 'main',
  
  // Portfolio creation modal tour
  PORTFOLIO: 'portfolio',
  
  // Transaction tutorials (AAPL, Gold, Sell, Custom)
  TRANSACTIONS: 'transactions',
  
  // Custom symbol creation flow
  CUSTOM_SYMBOLS: 'customSymbols',
  
  // Portfolio analysis section tour
  ANALYSIS: 'analysis',
  
  // Liabilities page tour (future)
  LIABILITIES: 'liabilities',
  
  // Net worth page tour (future)
  NET_WORTH: 'netWorth',
};

/**
 * Default onboarding progress structure.
 * Used when user has no progress data yet.
 */
export const DEFAULT_ONBOARDING_PROGRESS = {
  [TOUR_KEYS.MAIN]: { completed: false, skipped: false },
  [TOUR_KEYS.PORTFOLIO]: { completed: false, skipped: false },
  [TOUR_KEYS.TRANSACTIONS]: { completed: false, skipped: false, currentStep: 0 },
  [TOUR_KEYS.CUSTOM_SYMBOLS]: { completed: false, skipped: false },
  [TOUR_KEYS.ANALYSIS]: { completed: false, skipped: false },
  [TOUR_KEYS.LIABILITIES]: { completed: false, skipped: false },
  [TOUR_KEYS.NET_WORTH]: { completed: false, skipped: false },
};

/**
 * Helper to check if a tour is finished (completed or skipped)
 * @param {Object} progress - The onboardingProgress object from user
 * @param {string} tourKey - The tour key to check
 * @returns {boolean}
 */
export const isTourCompleted = (progress, tourKey) => {
  const tour = progress?.[tourKey];
  if (!tour) return false;
  return tour.completed === true || tour.skipped === true;
};

/**
 * Helper to get current step of a tour
 * @param {Object} progress - The onboardingProgress object from user
 * @param {string} tourKey - The tour key to check
 * @returns {number}
 */
export const getTourStep = (progress, tourKey) => {
  return progress?.[tourKey]?.currentStep ?? 0;
};

